import { Sample } from "../../../../../../@types/samples/types";

export function isSelectableLambdaRegressionRow(
  swdValue: number | null | undefined,
  pcdValue: number | null | undefined
) {
  return (
    swdValue != null &&
    pcdValue != null &&
    swdValue > 0 &&
    swdValue < 1 &&
    pcdValue > 0 &&
    pcdValue <= 1
  );
}

export function areArraysEqual(arr1: number[], arr2: number[]) {
  if (arr1.length !== arr2.length) return false;

  const sorted1 = [...arr1].sort();
  const sorted2 = [...arr2].sort();

  return sorted1.every((value, index) => value === sorted2[index]);
}

// Overload to return the object
export function getSampleSelectedIndexes(
  sample: Sample,
  returnObject: true
): { [key: number]: boolean };
// Overload to return the array
export function getSampleSelectedIndexes(
  sample: Sample,
  returnObject?: false
): number[];
export function getSampleSelectedIndexes(sample: Sample, returnObject?: boolean) {
  const lambdaCurves = sample.analysis_curves.lambda_curves;
  const sampleCurves = sample.input_sample_curves;
  const pc = sampleCurves.pc_model?.pc || [];
  const indexes = lambdaCurves?.indexes;
  const defaultSelectableIndexes = pc.reduce(
    (acc, _cur, index) => {
      acc[index] = isSelectableLambdaRegressionRow(
        lambdaCurves?.SwD?.[index],
        lambdaCurves?.PcD?.[index]
      );
      return acc;
    },
    {} as { [key: number]: boolean }
  );

  const selectedIndexes = pc.reduce(
    (acc, _cur, index) => {
      // If indexes is null, use the rows that have valid regression terms.
      acc[index] = indexes?.includes(index) ?? defaultSelectableIndexes[index];

      return acc;
    },
    {} as { [key: number]: boolean }
  );

  if (returnObject) {
    return selectedIndexes;
  }

  const mappedSelectedIndexes = Object.entries(selectedIndexes).map(
    ([index, selected]) => (selected ? Number(index) : null)
  );
  const filteredSelectedIndexes = mappedSelectedIndexes.filter(
    (index): index is number => index !== null
  );

  return filteredSelectedIndexes;
}
